import { faker } from '@faker-js/faker';
import { mockPaginate } from './paginate';
import { TeamMember } from '@dynamika-shared/types/teamMember';

export const generateTeamMember = () => ({
  id: faker.string.uuid(),
  fullName: `${faker.person.firstName()} ${faker.person.lastName()}`,
  email: faker.internet.email(),
  roles: faker.lorem.word(),
  organizationId: faker.lorem.word(),
  lastActivity: faker.date.past().toISOString(),
  enabled: faker.datatype.boolean(),
  siteCodes: faker.lorem.word(),
  subscriptions: [],
  features: [],
});

export function generateTeamMemberList(count: number): TeamMember[] {
  return faker.helpers.multiple(generateTeamMember, { count });
}

export function generatePaginatedRandomTeamMemberList(
  count: number,
  args = { page: 1, size: 10 }
) {
  const teamMemberList = generateTeamMemberList(count);
  return mockPaginate(teamMemberList, args);
}
